/* PROFILE */
export const GET_PROFILE = "GET_PROFILE"
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS"
export const GET_PROFILE_FAIL = "GET_PROFILE_FAIL"

export const UPDATE_PROFILE = "UPDATE_PROFILE"
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS"
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL"

export const UPDATE_USER_PWD = "UPDATE_USER_PWD"
export const UPDATE_USER_PWD_SUCCESS = "UPDATE_USER_PWD_SUCCESS"
export const UPDATE_USER_PWD_FAIL = "UPDATE_USER_PWD_FAIL"

export const RESET_PROFILE_STATE = 'RESET_PROFILE_STATE';
